var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttendeesBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 273,
    viewBox: "0 0 226 273",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M114.841 249.276C153.101 222.841 162.896 170.697 136.718 132.808C110.54 94.9194 58.3021 85.6344 20.0418 112.069C-18.2184 138.504 -28.0129 190.649 -1.83483 228.537C24.3433 266.426 76.5808 275.711 114.841 249.276ZM114.841 249.276L-23.7115 345.005M-16.3599 187.767C-12.8191 233.797 27.5227 267.91 73.7461 263.961C119.969 260.012 154.571 219.496 151.03 173.466C147.489 127.436 107.147 93.3228 60.9238 97.2718C14.7005 101.221 -19.9007 141.737 -16.3599 187.767ZM-16.3599 187.767L-29.1821 21.0777M103.663 104.907C61.8615 85.3119 11.7252 103.343 -8.32008 145.181C-28.3654 187.018 -10.7289 236.819 31.0721 256.414C72.8731 276.009 123.009 257.978 143.055 216.14C163.1 174.303 145.464 124.502 103.663 104.907ZM103.663 104.907L255.037 175.867",
    stroke: "black",
    strokeOpacity: 0.9,
    strokeWidth: 42.1328,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendeesBg);
export default __webpack_public_path__ + "static/media/attendeesBg.7701aa525657fee706d02ff6ed6813f2.svg";
export { ForwardRef as ReactComponent };